import React, { Fragment } from 'react';
import './Legend.scss';

export default function Legend() {
  return (
    <Fragment>
      <div className="ctns-legend">
        <div className="stopsell">x</div>
        <div>Stop Sell</div>
        <div className="cta">x</div>
        <div>Closed to arrival</div>
        <div className="ctd">x</div>
        <div>Closed to departure</div>
      </div>
    </Fragment>
  );
}
